export default function Star() {
  return <svg width="173" height="173" viewBox="0 0 173 173" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M109.621 57.6491L86.51 0L63.3852 57.6491L0 63.5611L48.2524 107.479L33.0408 173L86.5164 136.17L139.972 173L124.761 107.479L173 63.5611L109.621 57.6491ZM86.51 96.6677C81.6205 96.6677 77.6672 92.7287 77.6672 87.8685C77.6672 82.9888 81.6272 79.0497 86.51 79.0497C91.36 79.0497 95.3199 82.9888 95.3199 87.8685C95.3199 92.7287 91.36 96.6677 86.51 96.6677Z" fill="black"/>
  </svg>;

}
